import React from "react";
import "./PageStyles.css";

function SecurityTrust() {
  return (
    <div className="page-container">
      <h1>Security & Trust</h1>

      <p>
        Alpha APK Store™ takes website safety, transparency, and user trust
        seriously. We regularly check our website using public security and
        reputation tools.
      </p>

      <h2>Security Checks Performed</h2>

      <ul>
        <li>
          <strong>Google Safe Browsing:</strong> No unsafe content found.
        </li>

        <li>
          <strong>VirusTotal URL Scan:</strong> 0 / 92 security vendors flagged
          Alpha APK Store as malicious.
        </li>

        <li>
          <strong>HTTPS Protection:</strong> Active secure HTTPS connection.
        </li>

        <li>
          <strong>Security Headers:</strong> Site reached A-grade security
          header status after adding CSP, HSTS, X-Frame-Options,
          Permissions-Policy, Referrer-Policy, and X-Content-Type-Options.
        </li>

        <li>
          <strong>Content Security Policy:</strong> Active CSP protection helps
          reduce unsafe script and injection risks.
        </li>

        <li>
          <strong>HSTS:</strong> Active HTTP Strict Transport Security helps
          force secure HTTPS browsing.
        </li>

        <li>
          <strong>Search Console:</strong> Website ownership verified and pages
          are being indexed by Google.
        </li>

        <li>
          <strong>SEO Audit:</strong> Homepage reached 100 SEO score in
          Lighthouse testing.
        </li>
      </ul>

      <h2>APK Safety Notice</h2>

      <p>
        Alpha APK Store provides Android app information, compatibility details,
        screenshots, version information, and download guidance. Users should
        always review app permissions and scan downloaded APK files with trusted
        security tools before installing.
      </p>

      <h2>Transparency</h2>

      <p>
        Alpha APK Store does not claim ownership of third-party applications,
        logos, names, or trademarks. All rights belong to their respective
        owners.
      </p>

      <h2>Contact</h2>

      <p>
        For security concerns, copyright requests, broken links, or support,
        contact us at:
      </p>

      <p>
        <strong>alphaapkstore@gmail.com</strong>
      </p>
    </div>
  );
}

export default SecurityTrust;